
import PageContent from "./PageContent.vue";
import DispatchEventUtils from "./Mixins/DispatchEventUtils.js";
import ScreenUtils from "./Mixins/ScreenUtils.js";
import ExplanationMobile from "./ExplanationMobile.vue";
import LoginRequired from "./LoginRequired.vue";

export default {
  name: "ExplanationTablet",
  mixins: [DispatchEventUtils, ScreenUtils],
  inject: [
    'isLogged'
  ],
  components:{
    LoginRequired,
    ExplanationMobile,
    PageContent
  },
  props: {
    explanations: Array,
    selectedOrder: {
      type: Array,
      default: () => []
    },
    isText: Boolean
  },
  computed: {
    selectedExplanation() {
      if (this.selectedOrder === null){
        return null
      }
      return this.explanations.find(e => e.page_id === this.selectedOrder[0])
    }
  },
  methods: {
    selectExplanation(order) {
      if (this.selectedOrder.includes(order)){
        this.dispatch('FileViewer', 'show-explanation', {page:this.$parent.source, order: null, reset: true})
        return
      }
      this.dispatch('FileViewer', 'show-explanation', {page:this.$parent.source, order: order, reset: true})
    }
  }
}
